module.exports = __webpack_public_path__ + "img/saveing2.6f246d63.png";